'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import H3 from 'UIComponents/elements/headings/H3';
import Small from 'UIComponents/elements/Small';
import UISection from 'UIComponents/section/UISection';
import PracticalExerciseResubmitButtonContainer from './PracticalExerciseResubmitButtonContainer';
import PracticalExerciseRetryButtonContainer from './PracticalExerciseRetryButtonContainer';
import PracticalExerciseCondensedWrapper from './PracticalExerciseCondensedWrapper';
import PracticalExerciseProgressFeedback from './PracticalExerciseProgressFeedback';

const InReviewPracticalExerciseCondensed = ({
  advanceToNextContent,
  isManual,
  onResubmitClick,
  title,
  isPassRequiredForCert,
  resubmitType,
  contentId,
  trackId,
  lessonId
}) => {
  return /*#__PURE__*/_jsx(PracticalExerciseCondensedWrapper, {
    buttons: /*#__PURE__*/_jsxs(_Fragment, {
      children: [resubmitType === 'resubmit' ? /*#__PURE__*/_jsx(PracticalExerciseResubmitButtonContainer, {
        className: "m-right-3",
        "data-test-id": "practical-exercise-resubmit-button",
        exerciseName: title,
        onConfirm: onResubmitClick
      }) : /*#__PURE__*/_jsx(PracticalExerciseRetryButtonContainer, {
        className: "m-right-3",
        contentId: contentId,
        lessonId: lessonId,
        trackId: trackId
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: advanceToNextContent,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.continue`
        })
      })]
    }),
    children: /*#__PURE__*/_jsxs(PracticalExerciseProgressFeedback, {
      "data-test-id": "in-review-practical-exercise-condensed",
      illustrationName: "errors/hourglass",
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.statusTitle.submitted",
          options: {
            exerciseName: title
          }
        })
      }), isManual ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.statusSubtitle.submitted"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.auto.subtitle"
      }), !!isPassRequiredForCert && /*#__PURE__*/_jsx(UISection, {
        className: "m-top-1",
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.auto.continue"
          })
        })
      })]
    })
  });
};

InReviewPracticalExerciseCondensed.propTypes = {
  advanceToNextContent: PropTypes.func.isRequired,
  contentId: PropTypes.string.isRequired,
  isManual: PropTypes.bool,
  isPassRequiredForCert: PropTypes.bool,
  lessonId: PropTypes.string.isRequired,
  onResubmitClick: PropTypes.func.isRequired,
  resubmitType: PropTypes.oneOf(['resubmit', 'restart']),
  title: PropTypes.string.isRequired,
  trackId: PropTypes.string.isRequired
};
export default InReviewPracticalExerciseCondensed;